exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.oos-button[data-v-755cbc06] {\n  background-color: #95989A;\n  color: white;\n  width: auto;\n  height: 30px;\n  padding: 5px 12px;\n  font-size: 15px;\n}", ""]);

// exports
